import { IEntity } from "@interfaces/entity";
import { Manufacturer } from "@models/manufacturer";
import { Type } from "class-transformer";
import { Profile } from "@models/profile";

export class ModelDto implements IEntity {
  id: string;
  name: string;
  @Type(() => Manufacturer)
  manufacturer: Manufacturer;
  manufacturerId: number;
  @Type(() => Profile)
  profile: Profile;
  profileId: number;
  integrationDate?: Date;
  pictureUri: string;



  entityName: "modelDto";

  constructor(formValue?: Partial<ModelDto>) {
    Object.assign(this, formValue)
  }

  updateValues(formValue: Partial<ModelDto>) {
    Object.assign(this, formValue)
  }

  getPrimaryKey() {
    return this.id
  }

}
